import { Component, inject, computed, input } from '@angular/core';
import { AppService } from '../../app.service';
import { PhitoSessionService } from '../../../services/phito-session.service';
import { BackendApiService } from '../../../services/backend-api.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Document } from '../../../components/documents/document/document';

@Component({
    selector: 'phito-app-logo',
    templateUrl: './app-logo.component.html',
    styleUrls: ['./app-logo.component.scss'],
})
export class AppLogoComponent {
    private api = inject(BackendApiService);
    protected appService = inject(AppService);
    private phitoSessionService = inject(PhitoSessionService);
    private sanitizer = inject(DomSanitizer);

    logoHexId = input<string>();
    fileSuffix = input<string>();
    logo = input<any>();

    company = computed(() => this.phitoSessionService.phitoSession().company);

    documentResource = this.api.getSignal<Document>(() => {
        if (!this.logoHexId()) return;
        return `documents/${this.logoHexId()}`;
    }, 'Fehler beim Laden des Dokuments!');

    logoResource = this.api.getBlobSignal(() => {
        if (!this.documentResource.value()?.fileHexId) return;
        return `documentdata/file/${this.documentResource.value().fileHexId}`;
    }, 'Fehler beim Laden des Logos!');

    url = computed(() => {
        if (!this.logoResource.value()) {
            return;
        }
        return this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(this.logoResource.value()));
    });
}
